export default "__VITE_ASSET__CuuH83UY__"